import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import WhyUs from "./components/WhyUs";
import MissionVision from "./components/MissionVision";
import HowItWorks from "./components/HowItWorks";
import CareDirectory from "./components/CareDirectory";
import Cities from "./components/Cities";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import BookingForm from "./components/BookingForm";
import Footer from "./components/Footer";
import ServiceDetail from "./components/ServiceDetail";
import PartnerWithUs from "./components/PartnerWithUs";
import Careers from "./components/Careers";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions";
import { Toaster } from "./components/ui/toaster";
import useScrollReveal from "./hooks/useScrollReveal";
import { useEffect } from "react";
import { initLinkTracking } from "./lib/analytics";

function Home() {
  useScrollReveal([]);
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Services />
        <WhyUs />
        <MissionVision />
        <HowItWorks />
        <CareDirectory />
        <Cities />
        <Testimonials />
        <FAQ />
        <BookingForm />
      </main>
      <Footer />
    </>
  );
}

function App() {
  useEffect(() => initLinkTracking(), []);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/trained-attendees" element={<Navigate to="/services/trained-attendants" replace />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/partner" element={<PartnerWithUs />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
